import gql from 'graphql-tag';

export const AnnualReturnsTableData = gql`
	query AnnualReturnsTableData {
		allAnnualReturnsTable {
			tableHeading
			tableData {
				year
				fundrise
				reits
				stocks
			}
		}
	}
`;
